export function calcAmountFieldEdit(bill) {
    const _dict = __get_form_data(bill);
    if (_dict.is_fuel)
        _dict.fuel = Number(((_dict.amount + _dict.pickup + _dict.packaging + _dict.other) * (_dict.fuel_rate / 100)).toFixed(2));
    else
        _dict.fuel = 0;
    if (_dict.is_gst)
        _dict.gst = Number(((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.fuel) * (_dict.gst_rate / 100)).toFixed(2));
    else
        _dict.gst = 0;
    _dict.subtotal = Number((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.insurance + _dict.fuel).toFixed(2));
    _dict.total = Number((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.insurance + _dict.fuel + _dict.gst).toFixed(2));
    __set_form_data(_dict);
    return _dict;
}

export function adjustFuelFieldEdit(bill) {
    const _dict = __get_form_data(bill);
    let subtotal = _dict.amount + _dict.pickup + _dict.packaging + _dict.other
    _dict.fuel_rate = ((_dict.fuel / subtotal) * 100).toFixed(2);
    __set_form_data(_dict);
    calcAmountFieldEdit(_dict);
    return _dict;
}

export function adjustGstFieldEdit(bill) {
    const _dict = __get_form_data(bill);
    _dict.gst_rate = ((_dict.gst / _dict.subtotal) * 100).toFixed(2);
    __set_form_data(_dict);
    calcAmountFieldEdit(_dict);
    return _dict;
}
export function adjustSubTotalFieldEdit(bill) {
    const _dict = __get_form_data(bill);
    if (_dict.is_fuel) {
        _dict.fuel = Number(((_dict.amount + _dict.pickup + _dict.packaging + _dict.other) * (_dict.fuel_rate / 100)).toFixed(2));
        let diffrance = Number((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.fuel).toFixed(2)) - _dict.subtotal;
        diffrance = (diffrance * 100) / (100 + _dict.fuel_rate);
        _dict.other = Math.ceil((_dict.other - diffrance) * 100) / 100;
    } else {
        _dict.subtotal = _dict.total.toFixed(2);
    }
    __set_form_data(_dict);
    calcAmountFieldEdit(bill);
    return _dict;
}
export function adjustTotalFieldEdit(bill) {
    const _dict = __get_form_data(bill);
    if (_dict.is_fuel)
        _dict.fuel = Number(((_dict.amount + _dict.pickup + _dict.packaging + _dict.other) * (_dict.fuel_rate / 100)).toFixed(2));
    else
        _dict.fuel = 0;
    if (_dict.is_gst)
        _dict.gst = Number(((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.fuel) * (_dict.gst_rate / 100)).toFixed(2));
    else
        _dict.gst = 0;

    let diffrance = Number((_dict.amount + _dict.pickup + _dict.packaging + _dict.other + _dict.insurance + _dict.fuel + _dict.gst).toFixed(2)) - _dict.total;
    if (_dict.is_gst) {
        diffrance = (diffrance * 100) / (100 + _dict.gst_rate);
    }
    if (_dict.is_fuel) {
        diffrance = (diffrance * 100) / (100 + _dict.fuel_rate);
    }
    _dict.other = Math.ceil((_dict.other - diffrance) * 100) / 100;
    __set_form_data(_dict);
    calcAmountFieldEdit(_dict);
    return _dict;
}

function __get_form_data(bill) {
    const data = {
        "amount": Number(document.getElementsByName("amount")[0].value) || 0,
        "pickup": bill.pickup,
        "packaging": bill.packaging,
        "other": Number(document.getElementsByName("other")[0].value) || 0,
        "insurance": bill.insurance,
        "total": Number(document.getElementsByName("total")[0].value) || 0,
        "fuel": Number(document.getElementsByName("fuel")[0].value) || 0,
        "gst": Number(document.getElementsByName("gst")[0].value) || 0,
        "is_gst": document.getElementsByName("is_gst")[0].checked,
        "gst_rate": Number(document.getElementsByName("gst_rate")[0].value) || 0,
        "is_fuel": document.getElementsByName("is_fuel")[0].checked,
        "fuel_rate": Number(document.getElementsByName("fuel_rate")[0].value) || 0,
        "subtotal": Number(document.getElementsByName("subtotal")[0].value) || 0,
    }
    return data;
}

function __set_form_data(_dict) {
    document.getElementsByName("amount")[0].value = _dict['amount'];
    document.getElementsByName("other")[0].value = _dict['other'];
    document.getElementsByName("fuel")[0].value = _dict['fuel'];
    document.getElementsByName("gst")[0].value = _dict['gst'];
    document.getElementsByName("is_gst")[0].checked = _dict['is_gst'];
    document.getElementsByName("gst_rate")[0].value = _dict['gst_rate'];
    document.getElementsByName("is_fuel")[0].checked = _dict['is_fuel'];
    document.getElementsByName("fuel_rate")[0].value = _dict['fuel_rate'];
    document.getElementsByName("total")[0].value = _dict['total'];
    document.getElementsByName("subtotal")[0].value = _dict['subtotal'];
}
